import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Sunday Night Syndrome',
  description: "You spend hours every week building sessions from zero. By Monday morning, you're already exhausted — before a single client walks through the door."
}, {
  emoji: '🍃',
  title: 'Sessions Without Structure',
  description: 'Your classes feel disconnected. You mix random exercises, improvise transitions, and quietly wonder if your clients are actually progressing — or just moving.'
}, {
  emoji: '📱',
  title: 'Information Overload',
  description: "You search YouTube, Instagram, and Google — and find a thousand methods that contradict each other. You still don't know which framework actually delivers results."
}, {
  emoji: '😩',
  title: 'The Rep Counter Trap',
  description: "You became a coach to change lives. Instead, you feel like you're counting reps, managing logistics, and surviving each session rather than truly leading it."
}];
export function PainSection() {
  return <section className="py-12 px-4 bg-white border-y border-brand-gold/30" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-graphite mb-4" data-id="element-126">
          DO YOU RECALL THIS?
        </h2>

        <p className="text-lg text-brand-graphite/80 text-center mb-8 max-w-3xl mx-auto" data-id="element-127">
          You love coaching, but does programming steal all your energy before
          you even step into the gym? If you are a functional trainer, personal
          trainer, or studio owner, you probably know one of these situations:
        </p>

        <div className="grid sm:grid-cols-2 gap-4" data-id="element-128">
          {pains.map((pain, i) => <div key={i} className="bg-brand-cream p-4 sm:p-5 rounded-lg border border-brand-petrol/20" data-id="element-129">
              <div className="text-3xl mb-2" data-id="element-130">{pain.emoji}</div>
              <h3 className="text-lg font-bold text-brand-petrol mb-1.5" data-id="element-131">
                {pain.title}
              </h3>
              <p className="text-brand-graphite/80 leading-relaxed" data-id="element-132">
                {pain.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}